// DJB-240: pure helpers for the Accounts › Maps view — kept free of Leaflet
// so the data rules are unit-testable without a DOM map.

// Roughly all of Flanders (Belgian coast → Voeren, Dutch border → Brussels
// south edge), as Leaflet [[south, west], [north, east]] bounds. The map opens
// fitted to these, whatever the fleet's actual spread is.
export const FLANDERS_BOUNDS = [
  [50.68, 2.54],
  [51.51, 5.92],
];

// Coordinate sanity: both numbers finite, inside the WGS84 range, and not the
// (0, 0) "never geocoded" sentinel that some import paths leave behind.
export const hasCoordinates = (machine) => {
  if (!machine) return false;
  const lat = Number(machine.latitude);
  const lng = Number(machine.longitude);
  if (machine.latitude == null || machine.longitude == null) return false;
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false;
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return false;
  if (lat === 0 && lng === 0) return false;
  return true;
};

// Split the /machines/map-data payload into the machines that get a pin and
// the ones the "N niet op kaart" note counts.
export const splitMappable = (machines) => {
  const list = Array.isArray(machines) ? machines : [];
  const onMap = [];
  const offMap = [];
  list.forEach((machine) => {
    (hasCoordinates(machine) ? onMap : offMap).push(machine);
  });
  return { onMap, offMap };
};
